import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { saveAttractionRankings } from '~/services/AttractionsService';

import type { SaveRankingsPayload } from '~/types/attractionTypes';

import { attractionQueryKeys } from './attractionQueryKeys';

export function useSaveAttractionRankings() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (payload: SaveRankingsPayload) => {
      return await saveAttractionRankings(payload);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: attractionQueryKeys.lists() });
      enqueueSnackbar(`${variables.rankings.length} ranking(s) saved and view refreshed`, {
        variant: 'success',
      });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error saving rankings: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
